module.exports = __webpack_public_path__ + "img/xpc.d9240398.png";